import angular from 'angular';

angular
  .module('cxTaskflow')
  .controller('ResetTaskAssignedToDialogCtrl', [
    '$element',
    '$filter',
    'close',
    'dataCache',
    'enumCacheSvc',
    'translateListFilter',
    'oldUserId',
    'newUserId',
    'tasksForUser',
    'profile',
    resetTaskAssignedToDialogCtrl,
  ]);

function resetTaskAssignedToDialogCtrl(
  $element,
  $filter,
  close,
  dataCache,
  enumCacheSvc,
  translateListFilter,
  oldUserId,
  newUserId,
  tasksForUser,
  profile,
) {
  var vm = this;
  vm.profile = profile;
  vm.profiles = [];
  vm.hasTasksAssignedToOldUser = tasksForUser > 0;
  vm.replaceAllUsers = !vm.hasTasksAssignedToOldUser;
  vm.showUserSelector = !newUserId; //Only show user selector if the user is set unassigned

  vm.assignedTo = {
    assignedType: 0,
    userId: null,
    profile: null,
  };
  vm.oldUserName = '';
  vm.newUserName = '';

  dataCache.ready().then(function() {
    const users = dataCache.getArray('user');
    const oldUser = oldUserId ? users.find(x => x.userID === oldUserId) : null;
    if (oldUser) {
      vm.oldUserName = oldUser.firstName + ' ' + oldUser.lastName;
    }
    const newUser = newUserId ? users.find(x => x.userID === newUserId) : null;
    if (newUser) {
      vm.newUserName = newUser.firstName + ' ' + newUser.lastName;

      vm.assignedTo.assignedType = 2;
      vm.assignedTo.userId = newUserId;
    }
    vm.users = users
      .filter(x => x.isActive || !x.hidden)
      .filter(x => x.userID !== oldUserId)
      .map(function(user) {
        return {
          id: user.userID,
          label: `${user.firstName} ${user.lastName}`,
          isActive: user.isActive,
        };
      })
      .sortByProperty('name');
    enumCacheSvc.get('employeeprofile').then(function(data) {
      vm.profiles = data.map(({ key, value }) => ({
        id: key,
        value,
        label: translateListFilter(key, 'employeeprofile', value),
      }));
    });
  });

  vm.save = function() {
    $element.modal('hide');
    //Extract userid
    const { userId, ...rest } = vm.assignedTo;
    close(
      {
        ...rest,
        newUserId: userId,
        oldUserId: vm.replaceAllUsers ? null : oldUserId,
      },
      500,
    );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
